/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPORGANISATIONSUBCLASSIFICATION = {
    PassiveNonFinancialEntityPnfe: 'PNFE',
    ActiveNonFinancialEntityAnfe: 'ANFE',
    NonParticipatingFinancialInstitution: 'NPFI',
    ExemptBeneficialOwner: 'EBO',
    ParticipatingFinancialInstitution: 'PFI',
    DeemedCompliantFinancialInstitution: 'DCFI'
} as const;
export type IAPORGANISATIONSUBCLASSIFICATION = typeof IAPORGANISATIONSUBCLASSIFICATION[keyof typeof IAPORGANISATIONSUBCLASSIFICATION];


export function IAPORGANISATIONSUBCLASSIFICATIONFromJSON(json: any): IAPORGANISATIONSUBCLASSIFICATION {
    return IAPORGANISATIONSUBCLASSIFICATIONFromJSONTyped(json, false);
}

export function IAPORGANISATIONSUBCLASSIFICATIONFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPORGANISATIONSUBCLASSIFICATION {
    return json as IAPORGANISATIONSUBCLASSIFICATION;
}

export function IAPORGANISATIONSUBCLASSIFICATIONToJSON(value?: IAPORGANISATIONSUBCLASSIFICATION | null): any {
    return value as any;
}

